/**
 * 외근 일괄 결재 선택 규칙 — 대기/보고서 대기 "단일 단계"만 동시 선택 (스펙 §4).
 * 주의: admin은 "목록 순서상 첫 선택 레코드"가 단계를 정한다.
 * team-manager(attendance/approval-steps.ts)는 selectedIds[0] 기준 —
 * 의도된 앱별 차이(양쪽 모두 characterization으로 고정).
 */

/** 현재 선택된 건들의 단계(pending | report_pending). 빈 선택이면 "". */
export function offsiteSelectedStep(
  records: Record<string, unknown>[],
  selectedIds: string[],
): string {
  if (selectedIds.length === 0) {
    return "";
  }
  const first = records.find((r) => selectedIds.includes(r.id as string));
  return first ? (first.status as string) : "";
}

/** 행 선택 가능 — 대기/보고서 대기만, 이미 선택된 단계와 동일해야. */
export function offsiteRowSelectable(
  r: Record<string, unknown>,
  records: Record<string, unknown>[],
  selectedIds: string[],
): boolean {
  const st = r.status as string;
  if (st !== "pending" && st !== "report_pending") {
    return false;
  }
  const step = offsiteSelectedStep(records, selectedIds);
  return step === "" || step === st;
}

/** 헤더 체크박스 전체 선택 — 혼재 시 먼저 나온(상단) 단계 기준. */
export function offsiteSelectAllIds(
  records: Record<string, unknown>[],
  currentStep: string,
): string[] {
  const rows = records.filter((r) => r.status === "pending" || r.status === "report_pending");
  if (rows.length === 0) {
    return [];
  }
  const step = currentStep || (rows[0].status as string);
  return rows.filter((r) => r.status === step).map((r) => r.id as string);
}

/** 승인 이후 상태의 외근만 workDate("YYYY-MM-DD") 키로 매핑 — 대기/반려/취소는 근태에 미노출. */
export function offsiteConfirmedByDate(
  items: Record<string, unknown>[],
): Record<string, Record<string, unknown>> {
  const confirmedStatuses = new Set(["approved", "report_pending", "report_approved"]);
  const byDate: Record<string, Record<string, unknown>> = {};
  for (const ow of items) {
    if (!confirmedStatuses.has(String(ow.status))) {
      continue;
    }
    const key = String(ow.workDate || "").slice(0, 10);
    if (key) {
      byDate[key] = ow;
    }
  }
  return byDate;
}
